import { render, staticRenderFns } from "./FormModal.vue?vue&type=template&id=bba531d4&"
import script from "./FormModal.vue?vue&type=script&lang=js&"
export * from "./FormModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports